module.exports = "pegasus_template/assets/home-bg.png";